import Ambition from "./Ambition/Ambition";
import NotePersonnelleFormation from "./NotePersonnelleFormation/NotePersonnelleFormation";
import { élémentAffichéListeEtAperçuStore } from "@/components/_layout/ListeEtAperçuLayout/useListeEtAperçuStore/useListeEtAperçuStore";
import useÉlève from "@/features/élève/ui/hooks/useÉlève/useÉlève";
import Voeux from "@/features/formation/ui/Voeux/Voeux";

const FormationFavorite = () => {
  const formationAffichée = élémentAffichéListeEtAperçuStore();
  const { élève } = useÉlève();

  if (!élève || !formationAffichée) return null;

  return (
    <div className="grid gap-6 border border-solid border-[--border-default-grey] px-4 py-8 shadow-md sm:px-10">
      <Ambition />
      <hr className="pb-[1px]" />
      <Voeux />
      <hr className="pb-[1px]" />
      <NotePersonnelleFormation />
    </div>
  );
};

export default FormationFavorite;
